import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import PublishIcon from "@material-ui/icons/Publish";
import axios from "axios";
import useConfirm from "../../components/Control/useConfirm";
import { DivStyled } from "../Departments/container.style";

// the name / number are only entered here, afterwards they are changed from the
// ecn page and synced back to this list
const AddEditSpecialProcess = ({ categoryId, setIsProcessModal }) => {
  const [processData, setProcessData] = useState({});
  const inputElement = useRef(null);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    "SPECIAL PROCESS",
    "Are you sure you want to save this?",
  );

  useEffect(() => {
    if (inputElement.current) {
      inputElement.current.focus();
    }
  }, []);

  function handleProcessData(e) {
    setProcessData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSubmit = async () => {
    if (!processData.process_name) {
      alert("Process Name is required");
      return;
    }
    if (!processData.process_no) {
      alert("Process Number is required");
      return;
    }
    const ans = await confirmSubmit();
    if (!ans) return;

    await axios
      .post("/api/specialProcess/process", {
        ...processData,
        category_id: categoryId,
      })
      .then(() => setIsProcessModal(false))
      .catch((err) => console.log(err));
  };

  return (
    <section className="root-admin">
      <div
        className="btn_save"
        style={{
          position: "absolute",
          right: "150px",
          top: "9px",
        }}
      >
        <Button
          type="submit"
          variant="outlined"
          size="large"
          style={{ color: "#e9e9e9" }}
          startIcon={<PublishIcon />}
          onClick={handleSubmit}
        >
          SUBMIT
        </Button>
      </div>
      <DivStyled>
        <label htmlFor="process_name">Process Name:</label>
        <input
          type="text"
          id="process_name"
          name="process_name"
          ref={inputElement}
          defaultValue={processData?.process_name}
          onBlur={handleProcessData}
        />
      </DivStyled>
      <DivStyled>
        <label htmlFor="process_no">Process Number:</label>
        <input
          type="text"
          id="process_no"
          name="process_no"
          defaultValue={processData?.process_no}
          onBlur={handleProcessData}
        />
      </DivStyled>
      <DialogSubmit isSubmitContent={false} />
    </section>
  );
};

export default AddEditSpecialProcess;
